import React, { useState } from 'react';
import Cookies from 'js-cookie';

function IcsLink() {

  const [usericstoken, setUserIcsToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const calendarUrl = usericstoken
    ? `${window.location.origin}/api/get-calender-file/${usericstoken}`
    : '';

  const getIcsToken = async () => {
    setLoading(true);

    try {
      const res = await fetch('/api/create-calender-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: Cookies.get('token') })
      });

      const data = await res.json();
      setUserIcsToken(data.IcsToken);

    } catch (error) {
      console.error("Fehler beim Erstellen des Kalender-Links:", error);
    }

    setLoading(false);
  };

  const copyToClipboard = () => {
    if (!calendarUrl) return;
    navigator.clipboard.writeText(calendarUrl);
    alert("Link kopiert!");
  };

  return (
    <div className="p-4 border rounded-lg bg-gray-50">
      <h3>Dein persönlicher Kalender-Feed</h3>
      <p className="text-sm text-gray-600">
        Erstelle deinen persönlichen Kalender-Link und kopiere ihn in dein Kalenderprogramm (Outlook, Google, Apple).
      </p>

      <div className="mt-4 flex gap-2">
        <button
          onClick={getIcsToken}
          disabled={loading}
          className="bg-green-500 text-white px-4 py-2 rounded"
        >
          {loading ? "Wird erstellt..." : "Link generieren"}
        </button>
      </div>

      {usericstoken && (
        <div className="mt-4 flex gap-2">
          <input
            readOnly
            value={calendarUrl}
            className="flex-1 p-2 border rounded"
          />
          <button
            onClick={copyToClipboard}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Kopieren
          </button>
        </div>
      )}
    </div>
  );
}

export default IcsLink;
